import type {
  Address,
  English,
  ExternalProfile,
  PersonInterface,
  PersonName,
  Publications,
} from '~/interfaces/person'
import type { PersonCategory } from '~/constants/domain'

export default class Person implements PersonInterface {
  constructor(
    public path: string,
    public personId: string,
    public name: PersonName,
    public category: PersonCategory,
    public external: boolean,
    public phone: string,
    public email: string,
    public room: string,
    public picture: string,
    public externalProfiles: Array<ExternalProfile>,
    public website: string,
    public publications: Publications,
    public projects: Array<string>,
    public address: Address,
    public en: English,
  ) {}

  toJson(): object {
    return { ...this }
  }
}
